import React, { useState, useEffect, useContext} from "react";
import { useIntl } from "react-intl";
import Chart from "react-apexcharts";
import PropTypes from "prop-types";

import * as ChartUtils from "../../../Utils/ChartsUtils";
import * as Utils from "../../../Utils/AnalyticsUtils";
import CheckBox, {CheckBoxLabelSize} from "../../../UI/Button/CheckboxButton";
import { ThemeContext } from "../../../Context/ThemeWrapper";

import LogService from "../../../../middleware/CommonSdk/LogService";
const LOG_TAG = "ANALYTICS_CARD";

const AnalyticsCard = (props) => {
    const intl = useIntl();
    const themeContext = useContext(ThemeContext);

    const [isStacked, setIsStacked] = useState(false);
    const [xLabel, setXLabel] = useState([]);
    const [xLegend, setXLegend] = useState("---");
    
    useEffect(() => {
        if (props.xlabel && props.period) {
            setXLabel(props.xlabel);
            setXLegend(Utils.getXLegende(props.period, intl));
        }
    }, [props.xlabel, props.period]);

    const theme = {
        mode: themeContext.theme,
        //palette: 'palette2'
    };

    const optionsMetrics = {
        chart: {
            height: "100%",
            background: "transparent",
            stacked: isStacked,
            defaultLocale: ChartUtils.getDefaultLocale(intl),
            locales: ChartUtils.getAvailableLanguageCodes()
        },
        legend: {
            show: true,
            showForSingleSeries: true,
            position: "top",
            horizontalAlign: "left"
        },
        zoom: {enabled: false},
        dataLabels: {enabled: false},
        theme: theme,
        colors: ['#FF9800','#2E93fA'],
        stroke: {
            curve: "smooth",
            show: true,
            width: 2,
            colors: ['transparent']
        },
        grid: {
            show: true
        },
        yaxis: {
            labels: {formatter: function (value) {
                return (!isFinite(value))? 0 : 
                 Utils.nFormatter(value)
            }},
          },
        xaxis: {
            tickPlacement: "on",
            categories: xLabel,
            type: "datetime"
        },
        annotations: {
            xaxis: [{
              x: Date.now(),
              strokeDashArray: 0,
              borderColor: "#34b233",
              label: {
                borderColor: "#34b233",
                style: {
                  color: "#FFF",
                  background: "#34b233",
                },
                text: intl.messages.now
              }
            }]
        },
        responsive: [{
            breakpoint: 1000,
            options:{
                legend: {
                    position: "bottom"
                }
            }
        }],
        tooltip: {
            x: { 
                format: Utils.dateFormatter(props.period)
            }
        }
    }

    LogService.trace(LOG_TAG, "render");

    return (
        <div className="card border-primary">
            <div className="card-body text-center">
                <h3 className="mt-2 mb-4">{props.title}</h3>
                <Chart
                    options={optionsMetrics}
                    series={props.series}
                    type={props.type}
                />
                <h5 style={{fontVariantCaps: "all-small-caps"}}>{xLegend}</h5>
            </div>
            <div className="card-footer">
                { props.canStack && <div className="table-value">
                    <CheckBox
                        labelSize={CheckBoxLabelSize.Small}
                        checked={isStacked}
                        label={intl.messages.analyticsStack}
                        onClick={() => setIsStacked(!isStacked)}
                    /> 
                </div> }
            </div>
        </div>
    );
}

AnalyticsCard.defaultProps = {
    canStack: false,
    type: "line",
    series: []
}

AnalyticsCard.propTypes = {
    title: PropTypes.string,
    period: PropTypes.string,
    xlabel: PropTypes.array,
    canStack: PropTypes.bool,
    type: PropTypes.string,
    series: PropTypes.array
};

export default (AnalyticsCard);